<template>
  <div id="app">
    <AppHeader />
    <router-view v-if="!auth0InstanceIsLoading" class="view"></router-view>
    
    <div class="modal" v-if="showConfirmEmailModal" :class="{ 'is-active': true }">
      <div class="modal-background"></div>
        <div class="modal-content">
            <div class="box">
                <div class="title is-4">
                  Veuillez confirmer votre adresse email pour accéder à MyConso
                </div>
                <div>
                  <p class="label">Vous n'avez pas reçu votre email de confirmation?</p>
                  <div style="display: flex;justify-content: space-between;">
                    <button
                      @click="resendEmailValidationLink"
                      class="button is-outlined is-primary is-responsive">
                      Renvoyer un email de confirmation
                    </button>
                    <br>
                    <button
                      @click="closeConfirmEmailModal"
                      class="button is-outlined is-primary is-responsive"
                    >Ok</button>
                  </div>
                </div>
            </div>
        </div>
    </div>

    <CookieBanner :auth0ID="auth0ID" />

    <footer class="footer">
      <div class="content has-text-centered">
        <p><a @mousedown="$router.push('/legal-notice', () => {})">Mentions légales</a></p>
        <p><a @mousedown="$router.push('/gdpr', () => {})">Vie privée</a></p>
        <p>Pour toute question, <a @click="goTo('/faq')">consultez la F.A.Q.</a></p>
        <p>Made with love by <a href="https://www.ingestic.be" target="_blank">Ingestic</a></p>
      </div>
    </footer>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import CookieBanner from './components/CookieBanner.vue'
import { mapActions } from "vuex";
import { UserService, Auth0Service } from './services'

export default {
  data() {
    return {
      showConfirmEmailModal: false,
      auth0InstanceIsLoading: true,
      auth0ID: null
    }
  },
  components: {
    AppHeader,
    CookieBanner
  },
  computed: {
      userIsAuthenticated() {
          return this.$auth.isAuthenticated
      }
  },
  methods: {
    ...mapActions("labels", ["getLocale"]),
    ...mapActions("account", ["addAuth0User", "logoutAuth0User"]),
    ...mapActions("auth0", ["retrieveTokenFromAuthz"]),
    goTo(to) {
      this.$router.push(to, () => {})
    },
    closeConfirmEmailModal() {
      this.showConfirmEmailModal = false
      // Logout user
      this.logoutAuth0User()
    },
    resendEmailValidationLink() {
      Auth0Service.resendEmailValidation({ auth0ID: this.auth0ID }).then(() => {
        // Logout user
        this.logoutAuth0User()
      })
    },
  },
  async created() {
    this.getLocale()
    this.retrieveTokenFromAuthz().then(() => {
      this.auth0InstanceIsLoading = false
    }, () => {
      UserService.logoutAuth0User()
    })
  },
  watch: {
      async userIsAuthenticated() {
          if(this.userIsAuthenticated) {
            // get auth token
            let authToken = await this.$auth.getTokenSilently()
            // set auth token in localstorage
            localStorage.setItem("auth_token", authToken)
            // get claims
            let claims = await this.$auth.getIdTokenClaims()

            this.auth0ID = claims.sub
            // check if user email is verified, if not force email verif
            if(claims.email_verified) {
              Auth0Service.checkThatAuth0UserExists({ email: claims.email, auth0ID: claims.sub }).then(user => {
                // ajouter user en module account.user
                if(user) {
                  this.addAuth0User({ userToSave: user, authToken: authToken, email_verified: claims.email_verified })
                  localStorage.setItem("user-portal", JSON.stringify(user))
                }
              })
            }
            else {
              // display message
              this.showConfirmEmailModal = true
            }
          }
      },
  }
}
</script>
 
<style lang="scss" scoped>
.view {
  min-height: calc(100vh - 71.99px);
}
.right {
  float: right
}
</style>
